module.exports = __webpack_public_path__ + "img/logo.495bc412.png";